// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__HsL4C","album_wrapper":"Content_album_wrapper__aQrdE"};